@if (newsList?.length) {
  <div class="actions">
    @if (allExpanded) {
      <button mat-button class="basic-button" (click)="reduceAll()">
        {{ "actions.reduceAll" | translate }}
      </button>
    } @else {
      <button mat-button class="basic-button" (click)="expandAll()">
        {{ "actions.expandAll" | translate }}
      </button>
    }
  </div>
  @for (news of newsList; track news._id) {
    <o-card-news [news]="news" (toggleExpansion)="onToggleExpansion()"> </o-card-news>
  }
} @else {
  <p class="no-news">
    {{ emptyLabel | translate }}
  </p>
}
